import { render, staticRenderFns } from "./my-invest.vue?vue&type=template&id=0871ca84&scoped=true"
import script from "./my-invest.vue?vue&type=script&lang=js"
export * from "./my-invest.vue?vue&type=script&lang=js"
import style0 from "./my-invest.vue?vue&type=style&index=0&id=0871ca84&prod&lang=css"
import style1 from "./my-invest.vue?vue&type=style&index=1&id=0871ca84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871ca84",
  null
  
)

export default component.exports